import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProductGroupsService } from 'src/app/admin/1.tv/product-groups/product-groups.service';
import { ProductsService } from 'src/app/admin/1.tv/products/products.service';
import { SitesMatTableMaintComponent } from 'src/app/admin/1.tv/sites/sites-mat-table-maint/sites-mat-table-maint.component';
import { UsersService } from 'src/app/admin/1.tv/users/users.service';
import { StripeResponseService } from 'src/app/services/stripe-response.service';
import { GoogleMapsComponent } from 'src/app/shared/google-maps/google-maps.component';
import { CompanySiteToStoreService } from 'src/app/theBookableServices/services/company-site-to-store/company-site-to-store.service';

@Component({
  selector: 'app-app-search-site-view',
  templateUrl: './app-search-site-view.component.html',
  styleUrls: ['./app-search-site-view.component.scss']
})
export class AppSearchSiteViewComponent implements OnInit, AfterViewInit {
  @ViewChild('googleMaps') googleMaps: GoogleMapsComponent;
  @ViewChild('sitesMatTableMaint') sitesMatTableMaint: SitesMatTableMaintComponent;
  @ViewChild('sitesMatTableMaint2') sitesMatTableMaint2: SitesMatTableMaintComponent;

  public companyId: string;
  public siteId: string;

  constructor(
    private router: Router,
    private productGroupsService: ProductGroupsService,
    private productsService: ProductsService,
    private usersService: UsersService,
    private stripeResponseService: StripeResponseService,
    private companySiteToStoreService: CompanySiteToStoreService
  ) { }

  ngOnInit(): void {

    this.companyId = this.stripeResponseService.companyId;

  }

  ngAfterViewInit() {

    document.getElementById('preloader')?.classList.add('hide');

    this.googleMaps.UserCurrentLocationCompleteEvent.subscribe((currentLocation) => {

      console.log('AppSearchSiteComponent', currentLocation);

      this.sitesMatTableMaint.setLocation(currentLocation.position, 10);
      this.sitesMatTableMaint2.setLocation(currentLocation.position);
    });

    // this.sitesMatTableMaint.setLocation(currentLocation.position, 10)
  }
  userSiteConfirmationCompleteEvent(e: any) {



    this.stripeResponseService.companyId = e.companyId;
    this.stripeResponseService.siteId = e.companyId + '-' + e.siteId;

    // Earliest point for company and siteId, can get items here

    this.productGroupsService.getProductGroupsByCompanyId(this.stripeResponseService.companyId);
    this.productsService.getProductsByCompanyId(this.stripeResponseService.companyId);
    this.usersService.getUsersByCompanyId(this.stripeResponseService.companyId);


    // Does not make sense at the moment to use site filtering

    // // this.productGroupsService.getProductGroupsByCompanyId(this.stripeResponseService.companyId);
    // this.productGroupsService.getProductGroupsByCompanyIdSiteId(this.stripeResponseService.companyId, this.stripeResponseService.siteId)
    // // this.productsService.getProductsByCompanyId(this.stripeResponseService.companyId);
    // this.productsService.getProductsByCompanyIdSiteId(this.stripeResponseService.companyId, this.stripeResponseService.siteId)
    // this.usersService.getUsersByCompanyId(this.stripeResponseService.companyId);

    // this.router.navigate(['/'], { queryParams: { cId: e.companyId ,  sId: target } });
    console.log('this.stripeResponseService', this.stripeResponseService);

    // Sets up ngrx for the bookings/cancellations service to perfrom
    this.companySiteToStoreService.addCompanySiteUserLocation(this.stripeResponseService.companyId, this.stripeResponseService.siteId);

    // const userData = {
    //   displayName: this.stripeResponseService.currentLoggedInUser.displayName,
    //   email: this.stripeResponseService.currentLoggedInUser.email,
    //   emailVerified: this.stripeResponseService.currentLoggedInUser.emailVerified,
    //   photoURL: this.stripeResponseService.currentLoggedInUser.photoURL,
    //   roles: this.stripeResponseService.currentLoggedInUser.roles,
    //   uid: this.stripeResponseService.currentLoggedInUser.uid

    // }

    // const userData = {
    //   displayName: "Kelvin (Hard coded)",
    //   email: "kelvin.beech@admir.tv",
    //   emailVerified: true,
    //   photoURL: "https://goo.gl/Fz9nrQ",
    //   roles: {
    //     admir:false,
    //     areaManager:false,
    //     branchManager:false,
    //     companyManager:true,
    //     subscriber:false,
    //   },
    //   uid: "kuYHP5LBWHh8I8IBb3nfh4NWjQd2"

    // }

    // this.companySiteToStoreService.addSiteUser(userData);

    this.router.navigate(['/']);

  }

  sitesReadyCompleteEvent(e: any) {

    // console.log(e.sites)
  }

}
